import { render, staticRenderFns } from "./DlgOutrosList.vue?vue&type=template&id=9f94476c"
import script from "./DlgOutrosList.vue?vue&type=script&lang=js"
export * from "./DlgOutrosList.vue?vue&type=script&lang=js"
import style0 from "./DlgOutrosList.vue?vue&type=style&index=0&id=9f94476c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports